import { tw } from '../index';
import { useTrackEvent } from '../hooks/useTrackEvent';

export default function Link({
  text,
  datalayerValue,
  ...props
}: {
  text: string;
  datalayerValue: string;
  href: string;
}) {
  const trackEvent = useTrackEvent();

  return (
    <a
      target='_blank'
      rel='noopener noreferrer'
      className={tw`underline`}
      onClick={() => {
        trackEvent({
          event: 'uaevent',
          event_name: 'click',
          event_detail: datalayerValue,
        });
      }}
      {...props}
    >
      {text}
    </a>
  );
}
